/* PavCon, LLC Proprietary.All rights reserved 2022 */
import { RouterModule, Routes } from '@angular/router';
import { AuthLazyGuard } from './shared/guards/auth-lazy.guard';

import { NgModule } from '@angular/core';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./authentication/authentication.module').then((m) => m.AuthenticationModule),
  },
  {
    path: 'portal',
    canLoad: [AuthLazyGuard],
    loadChildren: () => import('./features/features.module').then((m) => m.FeatureModule),
  },
  {
    path: 'tutorials',
    loadChildren: () => import('./tutorials/tutorials.module').then((m) => m.TutorialsModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],

  exports: [RouterModule],
})
export class AppRoutingModule { }
/* PavCon, LLC Proprietary.All rights reserved 2022 */
